import { render, staticRenderFns } from "./duibi.vue?vue&type=template&id=b20f1842&scoped=true&"
import script from "./duibi.vue?vue&type=script&lang=js&"
export * from "./duibi.vue?vue&type=script&lang=js&"
import style0 from "./duibi.vue?vue&type=style&index=0&id=b20f1842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f1842",
  null
  
)

export default component.exports